import * as React from "react";
const SvgAppWindow = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.871 2.813v18.375H22.13V2.811H12ZM3.38 4.31H20.62v2.246H3.38V5.434Zm0 3.753H20.62V19.69H3.38v-5.812z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgAppWindow;
